<template>
    <div class="card" @click="goto_profile()">
        <div class="image">
            <img :src="person.dp"/>
        </div>
        <div>
            <div class="flex">
                <div class="name">{{ person.firstname + ' ' + person.lastname }}</div>
                <verified :size="'18px'" :style="{'height': '18px'}" v-if="person.verified"/>
            </div>
            <div class="username">@{{ person.username }}</div>
        </div>
    </div>
</template>

<script>
import verified from '../../icons/verified.vue';

export default {
    components: {
        verified
    },
    props: ['person'],
    methods: {
        
        goto_profile() {
            localStorage.setItem('profile', JSON.stringify(this.person))

            setTimeout(() => {
                this.$router.push('/profile/' + this.person.username)
            }, 250);
        },
    }
}
</script>

<style scoped>
    .card {
        background-color: white;
        border-radius: 5px;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        gap: 20px;
        padding: 10px 15px;
    }
    .image {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    img {
        width: 50px;
        display: block;
    }

    .flex {
        display: flex;
        align-items: center;
        gap: 5px;
        fill: var(--main);
    }
    .name {
        font-weight: 700;
        font-size: 14px;
    }
    .username {
        font-size: 12px;
        color: gray;
        margin-top: 3px;
    }
</style>